export default __webpack_public_path__ + "static/media/Emperors-Silk.31448384.jpg";